<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    @refresh="onRefresh"
    :disabled="dialogVisible"
  >
    <div :class="`${$style.pageContent}`">
      <div :class="`${$style.gameInfo}`">
        <img :src="activityInfo.gameIcon" />
        <div>
          <h3 :class="`${$style.title}`">{{ activityInfo.gameName }}</h3>
          <span :class="`${$style.tag}`">{{ activityInfo.tag }}</span>
        </div>
        <div @click="onSkipDetail" :class="`${$style.button}`">
          下载/查看游戏
        </div>
      </div>
      <div :class="`${$style.condition}`">
        <div :class="$style.time">
          <CountDown :time="countdownTime" @finish="onRefresh">
            <template #default="timeData">
              <div :class="$style.timeDown">
                <span :class="$style.label">礼包刷新倒计时：</span>
                <span>{{ timeData.days }}天</span>
                <span>{{ timeData.hours }}时</span>
                <span>{{ timeData.minutes }}分</span>
                <span>{{ timeData.seconds }}秒</span>
              </div>
            </template>
          </CountDown>
        </div>
        <div :class="$style.num">
          <div :class="$style.line">
            <p :class="$style.label">夺宝点：</p>
            <p :class="$style.value">
              <span>{{ activityInfo.point }}</span
              >(游戏内1元充值=1夺宝点)
            </p>
          </div>
          <div :class="$style.line2">
            <p :class="$style.rank">当前排名：</p>
            <div v-if="activityInfo.rankType == 0" :class="$style.point">
              <p>
                未入榜（夺宝点达
                <span>{{ activityInfo.originPoint }}</span> 入榜）
              </p>
              <p>
                距离入榜还差 <span>{{ activityInfo.needPoint }}</span> 夺宝点
              </p>
            </div>
            <div v-if="activityInfo.rankType == 1" :class="$style.point">
              <p>{{ activityInfo.rank }}</p>
              <p>
                再获取
                <span>{{ activityInfo.needPoint }}</span> 夺宝点即可成为榜单前十
              </p>
              <p>距离制霸榜单还差 {{ activityInfo.topNeedPoint }} 夺宝点</p>
            </div>
            <div v-if="activityInfo.rankType == 2" :class="$style.point">
              <p>{{ activityInfo.rank }}</p>
              <p>已进入前十名</p>
              <p>
                距离制霸榜单还差
                <span>{{ activityInfo.topNeedPoint }} </span>夺宝点
              </p>
            </div>
            <div v-if="activityInfo.rankType == 3" :class="$style.point">
              <p>1</p>
              <p>您已制霸该榜单！</p>
            </div>
          </div>
        </div>
      </div>

      <div :class="$style.rankTab">
        <div
          v-for="(item, index) in rankTab"
          :key="index"
          :class="`${$style.rankItem} ${
            item.id == selectRank ? $style.rankItemActive : ''
          }`"
          @click="onSelectTab(item)"
        >
          {{ item.desc }}
        </div>
      </div>

      <div :class="$style.rankContent">
        <img :src="activityInfo[rankTab[selectRank - 1].key[0]]" />
        <div :class="$style.desc">
          {{ activityInfo[rankTab[selectRank - 1].key[1]] }}
        </div>
        <div
          @click="onClickButton"
          :class="`${$style.button} ${
            activityInfo.rankType == 3 || (activityInfo.rankType == 2 && selectRank >= 2) || (activityInfo.rankType == 1 && selectRank == 3) ? $style.buttonActive : ''
          }`"
        >
          {{
            activityInfo.rankType == 3 || (activityInfo.rankType == 2 && selectRank >= 2) || (activityInfo.rankType == 1 && selectRank == 3)
              ? "可领取"
              : "打开游戏，获取夺宝点"
          }}
        </div>
        <p v-if="selectRank == 1">成为夺宝排行榜第一名可获得</p>
        <p v-if="selectRank == 2">进入夺宝排行榜前十名可获得</p>
        <p v-if="selectRank == 3">
          夺宝点达到{{ activityInfo.originPoint }}可获得
        </p>
      </div>

      <div :class="$style.rankList">
        <div :class="$style.header">
          <h3 :class="$style.title">夺宝点排行榜</h3>
          <div :class="$style.history" @click="onSkipHistory">
            <p>查看历史榜单</p>
            <img :src="`${CDN_URL_1}/box_win/6.png`" />
          </div>
        </div>
        <div :class="$style.listItemOne">
          <div :class="$style.ranking">排名</div>
          <div :class="$style.name">用户名</div>
          <div :class="$style.point">夺宝点</div>
        </div>
        <div :class="$style.rankListWrap">
          <div v-for="item in rankList" :key="item.uid" :class="$style.listItem">
            <div v-if="item.ranking <= 3" :class="$style.ranking">
              <img :src="rankIcon[item.ranking]" />
            </div>
            <div v-if="item.ranking > 3" :class="$style.ranking">
              {{ item.ranking }}
            </div>
            <div :class="$style.name">{{ item.userName }}</div>
            <div :class="$style.point">{{ item.point }}</div>
          </div>
        </div>
      </div>
      <!-- 弹窗 -->
      <ActivityDialog
        :title="dialogTitle"
        :visible="dialogVisible"
        :hideCancel="true"
        :sureText="sureText"
        @click-sure="onSureDialog"
        @click-cancel="dialogVisible = false"
        :herderStyle="{ background: '#ffb503' }"
      >
        <template v-slot:main>
          <div :class="$style.dialog">
            <p>夺宝结果将于每日24点结算，</p>
            <p>届时如果仍满足对应条件的话，</p>
            <p>会将礼包下发至您的账户，</p>
            <p>请在</p>
            <p>【我的】-【我的礼包】-【活动礼包】</p>
            <p>内查收</p>
          </div>
        </template>
      </ActivityDialog>
    </div>
  </PullRefresh>
</template>

<script>
import { CDN_URL_1, CDN_URL } from "@/config";
import {
  setPageTitle,
  toLogin,
  jumpToNative,
  clickRightTxt,
  setRightTxtColor,
  setRightTxt,
  loginSuccess,
  phoneBackButtonListener,
} from "@/bridge/AppJsBridge";
import { PullRefresh, CountDown } from "vant";
import ActivityDialog from "@/components/btBox/ActivityDialog";
import { getCookie } from "@/libs/utils";
import {
  getWinTreasureDetailApi,
  getWinTreasureRankApi,
} from "@/apis/wxActivity";
import { burnPoint } from "@/apis/heziShare";
import moment from "moment";

export default {
  name: "",
  components: {
    PullRefresh,
    ActivityDialog,
    CountDown,
  },
  data() {
    return {
      CDN_URL_1: CDN_URL_1,
      CDN_URL: CDN_URL,
      pageTitle: "",
      activityId: "",
      isLoading: false,
      cookie: null,
      dialogVisible: false,
      dialogTitle: "温馨提示",
      sureText: "我知道了",
      activityInfo: {
        gameName: "",
        gameIcon: "",
        remindTime: "",
        rankType: 0,
      },
      rankTab: [
        {
          id: 1,
          desc: "夺宝榜第1名礼包",
          key: ["firstGiftIcon", "firstGiftContent"],
        },
        {
          id: 2,
          desc: "夺宝榜前10名礼包",
          key: ["tenGiftIcon", "tenGiftContent"],
        },
        {
          id: 3,
          desc: "夺宝参与礼包",
          key: ["giftIcon", "giftContent"],
        },
      ],
      selectRank: 1, // 1-夺宝榜第1 2-夺宝榜前10 3-夺宝榜参与
      rankIcon: {
        1: `${CDN_URL_1}/box_win/3.png`, // 第一名
        2: `${CDN_URL_1}/box_win/4.png`, // 第二名
        3: `${CDN_URL_1}/box_win/5.png`, // 第三名
      },
      rankList: [],
    };
  },
  created() {
    loginSuccess(() => {
      this.initPageData();
    })
  },
  activated() {
    setRightTxt("活动规则");
    this.initPageData();
    try {
      phoneBackButtonListener((data, callBack) => {
        callBack('1')
      });
    } catch (error) {
      console.log("error:", error)
    }
  },
  computed: {
    countdownTime: function () {
      let time = 7 * 24 * 60 * 60 * 1000;
      if (this.activityInfo.remindTime) {
        time = this.activityInfo.remindTime * 1000;
      }
      return time;
    },
  },
  watch: {},
  methods: {
    // 下拉刷新
    async onRefresh() {
      await this.initPageData();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },

    // 数据上报
    eventTrack(data) {
      // this.$toast(data.event);
      console.log("正常数据上报", data.event);
      burnPoint({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },

    // 获取缓存等携带的用户信息数据
    async initPageData() {
      this.setHeaderContent();
      const { history } = this.$router;
      const { query } = history.current;
      if (!query.activityId) {
        return;
      }
      this.pageTitle = query.activityName;
      this.activityId = query.activityId;
      setPageTitle(query.activityName);
      const pageCookie = getCookie();
      if (pageCookie) {
        for (const key in pageCookie) {
          if (
            Object.hasOwnProperty.call(pageCookie, key) &&
            pageCookie[key] === "null"
          ) {
            delete pageCookie[key];
          }
        }
        this.cookie = pageCookie;
      }
      // 获取token
      this.getAppToken();
    },

    // 获取登录态
    getAppToken() {
      if (getCookie("token")) {
        localStorage.setItem("token", getCookie("token"));
        this.getActivityDetail();
      } else {
        toLogin("/loginKey/LoginByKeyPhoneActivity");
      }
    },

    // 切换夺宝礼包榜单
    onSelectTab(data) {
      this.selectRank = data.id;
    },

    // 点击按钮
    onClickButton() {
      const { rankType } = this.activityInfo;
      if (rankType == 3 || (rankType == 2 && this.selectRank >= 2) || (rankType == 1 && this.selectRank == 3)) {
        this.eventTrack({
          event: "seize_treasures_page_can_get",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
            amount: this.activityInfo.point,
            sort: this.activityInfo.rank,
            gift_type: this.selectRank,
          }),
          appName: this.activityInfo.gameName,
          appkey: this.activityInfo.gameId,
        });
        this.dialogVisible = true;
        this.eventTrack({
          event: "seize_treasures_page_tip_pop",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
            gift_type: this.selectRank,
          }),
          appName: this.activityInfo.gameName,
          appkey: this.activityInfo.gameId,
        });
      } else {
        this.eventTrack({
          event: "seize_treasures_page_cant_get",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
            amount: this.activityInfo.point,
            sort: this.activityInfo.rank,
            gift_type: this.selectRank,
          }),
          appName: this.activityInfo.gameName,
          appkey: this.activityInfo.gameId,
        });
        this.onSkipDetail(false);
      }
    },

    // 获取活动详情
    getActivityDetail() {
      getWinTreasureDetailApi({ activeId: this.activityId })
        .then((res) => {
          const { data } = res;
          this.activityInfo = data;
          this.eventTrack({
            event: "seize_treasures_page",
            event_field: JSON.stringify({
              act_id: this.activityId,
              act_name: this.pageTitle,
              amount: data.point,
              sort: data.rank || null,
            }),
            appName: this.activityInfo.gameName,
            appkey: this.activityInfo.gameId,
          });
          setTimeout(() => {
            this.getRankList();
          }, 800);
        })
        .catch((err) => {
          const { response } = err;
          if (response) {
            const { data } = response;
            if (data && data.code === 401) {
              toLogin("/loginKey/LoginByKeyPhoneActivity");
            }
          }
        });
    },

    // 确认弹窗
    onSureDialog() {
      this.dialogVisible = false;
    },

    // 游戏详情
    onSkipDetail(hasPoint = true) {
      if (hasPoint) {
        this.eventTrack({
          event: "seize_treasures_page_look_game",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
          appName: this.activityInfo.gameName,
          appkey: this.activityInfo.gameId,
        });
      }
      const data = {
        routePath: "/main/game/GameDetailActivity",
        fromPageType: 40,
        extraParams: this.activityInfo.gameId,
      };
      const dataStr = JSON.stringify(data);
      jumpToNative(dataStr);
    },

    // 设置顶部内容
    setHeaderContent() {
      setRightTxtColor("#6879AD");
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.$router.push({
          name: `box.actPlaceRule`,
          params: {
            type: 21,
          },
        });
        this.eventTrack({
          event: "double_welfare_rule",
          event_field: JSON.stringify({
            act_id: this.activityId,
            act_name: this.pageTitle,
          }),
        });
      });
    },

    // 游戏榜单
    getRankList() {
      let date = new moment().format("YYYY-MM-DD");
      getWinTreasureRankApi({
        activeId: this.activityId,
        gameId: this.activityInfo.gameId,
        date,
      }).then((res) => {
        if (!res.data) {
          this.rankList = [];
        }else{
          let { rankList = [] } = res.data;
          this.rankList = rankList;
        }
      });
    },

    // 历史夺宝榜单
    onSkipHistory() {
      this.eventTrack({
        event: "seize_treasures_history_range_look",
        event_field: JSON.stringify({
          act_id: this.activityId,
          act_name: this.pageTitle,
        }),
        appName: this.activityInfo.gameName,
        appkey: this.activityInfo.gameId,
      });
      this.$router.push({
        name: `box.wxWinTreasures.history`,
        query: {
          activityId: this.activityId,
          gameId: this.activityInfo.gameId,
        },
      });
    },
  },
};
</script>

<style lang="scss">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
<style lang="scss" module>
.pageContent {
  width: 100%;
  min-height: 100vh;
  max-width: 375px;
  margin: auto;
  overflow: auto;
  background-size: cover;
  background: #f6f6f6;
  position: relative;

  .gameInfo {
    // width: 100%;
    height: 82px;
    background: #ffffff;
    border-radius: 4px;
    margin: 6px 12px 6px;
    display: flex;
    align-items: center;
    padding: 0 14px;
    > img {
      width: 55px;
      height: 55px;
      margin-right: 8px;
    }
    .title {
      font-size: 17px;
      font-weight: 700;
      text-align: left;
      color: #a1583e;
      width: 140px;
      line-height: 20px;
      margin-bottom: 4px;
    }
    .tag {
      height: 18px;
      line-height: 20px;
      padding: 0 9px;
      background: #ff6d6d;
      border-radius: 2px;
      text-align: center;
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
    }
    .button {
      width: 108px;
      height: 30px;
      line-height: 30px;
      background: linear-gradient(
        44deg,
        rgba(255, 85, 11, 0.87) 0%,
        rgba(255, 132, 21, 0.87) 90%
      );
      border-radius: 14px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      font-size: 15px;
      margin-left: 9px;
    }
  }

  .condition {
    height: 123px;
    background: #ffffff;
    border-radius: 4px;
    margin: 6px 12px 6px;
    padding: 0 14px;
    .time {
      padding-top: 10px;
      .timeDown {
        display: flex;
        align-items: flex-start;
      }
      .label {
        font-size: 17px !important;
        font-weight: 700 !important;
        color: #535353 !important;
        display: inline-block;
      }
      span {
        line-height: 18px;
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        display: inline-block;
      }
    }
    .num {
      height: 82px;
      background: #fff5ec;
      border-radius: 7px;
      margin-top: 8px;
      padding: 14px 0 14px 25px;
      .line {
        display: flex;
        align-items: center;
        .label {
          color: #333333;
          font-size: 16px;
          font-weight: 700;
        }
        .value {
          color: #333333;
          font-size: 15px;
          span {
            color: #ff6d6d;
            // font-size: 15px;
            font-weight: 500;
            margin-right: 8px;
          }
        }
      }
      .line2 {
        display: flex;
        margin-top: 5px;
        .rank {
          font-size: 12px;
          font-weight: 500;
          text-align: left;
          color: #9f7155;
          line-height: 15px;
          //   padding-top: 1px;
        }
        .point {
          font-size: 12px;
          font-weight: 500;
          text-align: left;
          color: #9f7155;
          line-height: 15px;
          span {
            color: #ff6d6d;
          }
        }
      }
    }
  }
  .rankTab {
    display: flex;
    align-items: center;
    height: 42px;
    justify-content: center;
    .rankItem {
      width: 100px;
      height: 42px;
      background: #ffffff;
      font-weight: 500;
      font-size: 13px;
      border-radius: 4px;
      text-align: center;
      margin: 0 6px;
      color: #464646;
    }
    .rankItem:nth-child(1) {
      padding: 6px 10px;
      line-height: 16px;
    }
    .rankItem:nth-child(2) {
      padding: 6px 10px;
      line-height: 16px;
    }
    .rankItem:nth-child(3) {
      line-height: 42px;
    }
    .rankItemActive {
      background: #ff9916 !important;
      color: #ffffff !important;
    }
  }
  .rankContent {
    background: #ffffff;
    border-radius: 4px;
    margin: 6px 12px 6px;
    height: 184px;
    padding: 12px;
    img {
      width: 46px;
      height: 46px;
      display: block;
      margin: 0 auto 6px;
    }
    .desc {
      font-weight: 500;
      text-align: left;
      color: #9f7155;
      line-height: 14px;
      font-size: 13px;
      width: 220px;
      margin: auto;
    }
    .button {
      width: 231px;
      height: 34px;
      line-height: 34px;
      margin: 12px auto;
      background: #ababab;
      border-radius: 15.63px;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      font-size: 15.5px;
    }
    .buttonActive {
      background: linear-gradient(
        44deg,
        rgba(255, 85, 11, 0.87) 0%,
        rgba(255, 132, 21, 0.87) 90%
      ) !important;
    }
    p {
      text-align: center;
      color: #464646;
      font-weight: 500;
      font-size: 13px;
    }
  }
  .rankListWrap {
    min-height: 320px;
    max-height: 338px;
    overflow: auto;
  }
  .rankList {
    background: #ffffff;
    border-radius: 7px;
    margin: 6px 12px 6px;
    // min-height: 320px;
    padding: 12px 24px;
    .header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      padding-bottom: 4px;
      h3 {
        font-size: 16px;
        font-weight: 700;
        text-align: center;
        color: #464646;
        line-height: 16px;
        padding-left: 5px;
      }
      .title::before {
        content: " ";
        width: 4px;
        height: 18px;
        line-height: 18px;
        background: linear-gradient(
          0deg,
          rgba(250, 209, 38, 1) 0%,
          #ff544f 100%
        );
        display: inline-block;
        position: absolute;
        left: -5px;
      }
      .history {
        font-size: 12px;
        height: 13px;
        color: #888888;
        font-weight: 500;
        display: flex;
        align-items: center;
        img {
          width: 14px;
          margin-left: 1px;
        }
      }
    }
    .listItemOne {
      margin-bottom: 4px;
    }
    .listItem:nth-child(1) {
      margin-top: 8px;
    }
    .listItem,
    .listItemOne {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 12px;
      div {
        color: #464646;
        font-weight: 500;
        text-align: left;
        font-size: 14px;
      }
      .ranking {
        width: 60px;
        text-align: center;
        img {
          width: 24px;
        }
      }
      .name {
        width: 160px;
        text-align: center;
      }
      .point {
        width: 60px;
        text-align: center;
      }
    }
    .listItemOne div {
      color: #888888 !important;
    }
  }
  .dialog {
    max-height: 334px;
    overflow: auto;
    > p:nth-child(5) {
      color: #ff6d6d;
      width: auto;
    }
  }
}
</style>
